<div *ngIf="verificationFailed">
  <div class="flex-centered">
    <mat-icon mat-dialog-title class="warning-icon" style="">warning</mat-icon>
    <h1 mat-dialog-title class="title-margin">Bitte fülle folgende Felder aus:</h1>
  </div>
  <div mat-dialog-content>
    <p>Klicke auf das aufgelistete Feld, um zur gewünschten Seite zu gelangen:</p>
  </div>
  <div mat-dialog-content *ngIf="verificationResource.startup.length > 0" class="verify-warning">
    <div class="warning-position">
      <h4>Profil:</h4>
    </div>
    <ul>
      <li *ngFor="let pnote of verificationResource.startup" class="warning-list-element">
        <a class="warning-text" (click)="navigateTo(routes.profile)">{{ startupKeyToName[pnote.propertyPath] }}</a>
      </li>
    </ul>
  </div>
  <div mat-dialog-content *ngIf="verificationResource.product.length > 0" class="verify-warning">
    <div class="warning-position">
      <h4>Produkt:</h4>
    </div>
    <ul>
      <li *ngFor="let pnote of verificationResource.product" class="warning-list-element">
        <a class="warning-text" (click)="navigateTo(routes.product)">{{ productKeyToName[pnote.propertyPath] }}</a>
      </li>
    </ul>
  </div>
  <div mat-dialog-actions class="actions">
    <markant-button class="blue button" (click)="cancel()">Weiter bearbeiten</markant-button>
  </div>
</div>

<div *ngIf="!verificationFailed">
  <h1 mat-dialog-title style="text-align: center">Bist Du soweit?</h1>
  <div mat-dialog-content class="dialog-content">
    <p class="confirmation-info">Nachdem Du deine Bewerbung eingereicht hast, kannst du diese nicht mehr bearbeiten.</p>

    <ng-container *ngIf="cycle">
      <p>{{ cycle.name }} am {{ cycle.pitchDate | moment: 'date' }} in {{ cycle.location }}</p>
      <p class="description">
        {{ cycle.description }}
      </p>
      <p>Bis zum {{ cycle.feedback | moment: 'date' }} melden wir uns bei dir per E-Mail. Bitte halte dir den Termin bis dahin frei.</p>
    </ng-container>
  </div>
  <div mat-dialog-actions class="actions">
    <markant-button
      class="pink publish button"
      [disabled]="!verificationResource || verificationResource.startup.length > 0 || verificationResource.product.length > 0"
      (click)="publish()"
      >Ja, ich will mich bewerben
    </markant-button>
    <markant-button class="blue button" (click)="cancel()">Nein, noch nicht</markant-button>
  </div>
</div>
